export const ru = {
    'request-error': 'Произошла ошибка. Попробуйте еще раз.'
};
